import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})

export class MaskService {
  constructor() { }

  formataMoeda(element) {
    // Obtém o valor atual do campo
    let valor = element.target.value.replace(/\D/g, '');

    // Converte o valor para número
    const numero = parseInt(valor, 10) / 100;

    // Formata o número como moeda brasileira
    const valorFormatado = numero.toLocaleString('pt-BR', {
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    if (valorFormatado.length) {
      element.target.value = valorFormatado;
    } else {
      element.target.value = "0,00";
    }
  }

  formatarMedidaFisica(value, decimal, limit = 12) {
    let negativo = String(value)?.startsWith('-');
    let valor = String(value)?.replace(/\D/g, '');
    valor = valor.replace(/^0+/, '');
    if (valor) {
      if (valor.length > limit) {
        valor = valor.slice(0, limit);
      }
      if (decimal > 0) {
        const parteInteira = valor.slice(0, -decimal);
        const parteDecimal = valor.slice(-decimal);
        const parteInteiraFormatada = parteInteira.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        if(valor.length <= decimal){
          valor = `${parteDecimal}`;
        } else if (valor.length > decimal) {
          valor = `${parteInteiraFormatada},${parteDecimal}`;
        }
      }
      else {
        valor = valor.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      }
    }

    if(negativo){
      valor = '-' + valor;
    }

    return valor;
  }

  formatarNumProa(value) {
    let inputValue = value.replace(/\D/g, '');
    let numeroProa = '';

    if (inputValue.length > 14) {
      inputValue = inputValue.slice(0, 14);
    }
    if (inputValue.length > 0) {
      if (inputValue.length <= 2) {
        numeroProa = inputValue;
      } else if (inputValue.length <= 6) {
        numeroProa = inputValue.slice(0, 2) + '/' + inputValue.slice(2);
      } else if (inputValue.length <= 13) {
        numeroProa = inputValue.slice(0, 2) + '/' + inputValue.slice(2, 6) + '-' + inputValue.slice(6);
      } else {
        numeroProa = inputValue.slice(0, 2) + '/' + inputValue.slice(2, 6) + '-' + inputValue.slice(6, 13) + '-' + inputValue.slice(13);
      }
    }
    return numeroProa;
  }

  formataCpf(value) {

    value = value.replace(/\D/g, '');

      if (value.length > 11) {
        value = value.slice(0, 11);
      }

      if (value.length > 9) {
        value = value.replace(/(\d{3})(\d{3})(\d{3})(\d{1,2})/, "$1.$2.$3-$4");
      } else if (value.length > 6) {
        value = value.replace(/(\d{3})(\d{3})(\d{1,3})/, "$1.$2.$3");
      } else if (value.length > 3) {
        value = value.replace(/(\d{3})(\d{1,3})/, "$1.$2");
      } else {
        value = value.replace(/(\d{1,3})/, "$1");
      }

      return value
  }

  imprimeCpf(value) {

    value = value.replace(/\D/g, '');

      if (value.length > 11) {
        value = value.slice(0, 11);
      }

      value = value.padStart(11, '0');

      if (value.length > 9) {
        value = value.replace(/(\d{3})(\d{3})(\d{3})(\d{1,2})/, "$1.$2.$3-$4");
      } else if (value.length > 6) {
        value = value.replace(/(\d{3})(\d{3})(\d{1,3})/, "$1.$2.$3");
      } else if (value.length > 3) {
        value = value.replace(/(\d{3})(\d{1,3})/, "$1.$2");
      } else {
        value = value.replace(/(\d{1,3})/, "$1");
      }

      return value
  }

  
  maskPhoneComplete(value: string) {
    if(value){
      let newVal = value?.replace(/\D/g, '') ?? '';
      if (newVal.length === 0) {
        newVal = '';
      } else if (newVal.length <= 2) {
        newVal = newVal.replace(/^(\d{0,2})/, '($1)');
      } else if (newVal.length <= 6) {
        newVal = newVal.replace(/^(\d{0,2})(\d{0,4})/, '($1) $2');
      } else if (newVal.length <= 10) {
        newVal = newVal.replace(/^(\d{0,2})(\d{0,4})(\d{0,4})/, '($1) $2-$3');
      } else {
        newVal = newVal.substring(0, 11);
        newVal = newVal.replace(/^(\d{0,2})(\d{0,5})(\d{0,4})/, '($1) $2-$3');
      }
      return newVal
    }
    return null;
  }
  
  maskPhone(value: string) {
    if(value){
      let newVal = value?.replace(/\D/g, '') ?? '';
      if (newVal.length === 0) {
        newVal = '';
      } else if (newVal.length <= 4) {
        newVal = newVal.replace(/^(\d{0,4})/, '$1');
      } else if (newVal.length <= 8) {
        newVal = newVal.replace(/^(\d{0,4})(\d{0,4})/, '$1-$2');
      } else {
        newVal = newVal.substring(0, 9);
        newVal = newVal.replace(/^(\d{0,5})(\d{0,4})/, '$1-$2');
      }
      return newVal
    }
    return null;
  }

  maskCpf(value:string){
    if(value){
      let newVal = value?.replace(/\D/g, '') ?? '';
      if (newVal.length === 0) {
        newVal = '';
      } else if (newVal.length <= 3) {
        newVal = newVal.replace(/^(\d{0,3})/, '$1');
      } else if (newVal.length <= 6) {
        newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, '$1.$2');
      } else if (newVal.length <= 9) {
        newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})/, '$1.$2.$3');
      } else{
        newVal = newVal.substring(0, 11);
        newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2})/, '$1.$2.$3-$4');
      }
      return newVal
    }
    return null;
  }

  maskMoney(value:string):string|null{
    if(value){
      var fixValue = value?.replace(',', '.'); 
      if(fixValue?.split('.')?.[1]?.length > 2){
        var newValue = parseFloat(value).toFixed(2);
        return newValue;
      }
      return fixValue;
    }
    return null;
  }

  maskInteger(value:string):string|null{
    if(value && parseFloat(value)){
      var newValue = parseFloat(value)?.toFixed(0);
      return newValue;
    }
    return null;
  }
  maskNumeric(value:string){
    if(value){
      let newVal = value?.replace(/\D/g, '') ?? '';
      return newVal;
    }
    return null;
  }
  maskProjetoId(value:number):string|null{
    if(value){
      var newVal = value.toString();
      if (!newVal) {
        newVal = '';
      } else {
        newVal = newVal.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      }
      return newVal;
    }
    return null;
  }


  
  mascaraProcesso(valor: string): string {
    valor = valor.replace(/[^0-9]/g, '').substring(0, 14);
    valor = valor.replace(/^(\d{2})(\d)/, '$1/$2');
    valor = valor.replace(/^(\d{2})\/(\d{4})(\d)/, '$1/$2-$3');
    valor = valor.replace(/^(\d{2})\/(\d{4})-(\d{7})(\d)/, '$1/$2-$3-$4');
    return valor
  }
}
